import { ComponentStylesWithFns } from '../../theme/styles.helpers';

export const CalendarStyles: ComponentStylesWithFns = {
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    overscrollBehavior: 'none',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '112px',
    marginX: 'auto',
    width: '90%',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: 3,
    marginX: 'auto',
    width: '90%',
    paddingBottom: '24px',
  },
  calendarPaper: {
    padding: 3,
    borderRadius: 2,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
    '& .fc': {
      fontFamily: 'Outfit, Roboto, Helvetica, Arial, sans-serif',
    },
    '& .fc-header-toolbar': {
      fontFamily: 'Outfit, Roboto, Helvetica, Arial, sans-serif',
      marginBottom: '1.5em',
    },
    '& .fc-toolbar-title': {
      fontFamily: 'Outfit, Roboto, Helvetica, Arial, sans-serif',
    },
    '& .fc-button': {
      fontFamily: 'Outfit, Roboto, Helvetica, Arial, sans-serif',
      backgroundColor: '#000000',
      borderColor: '#000000',
      '&:hover': {
        backgroundColor: '#333333',
        borderColor: '#333333',
      },
      '&:focus': {
        boxShadow: '0 0 0 0.2rem rgba(0, 0, 0, 0.25)',
      },
    },
    '& .fc-event-title': {
      fontFamily: 'Outfit, Roboto, Helvetica, Arial, sans-serif',
    },
    '& .fc-daygrid-more-link': {
      fontFamily: 'Outfit, Roboto, Helvetica, Arial, sans-serif',
    },
    '& .fc-button-primary:not(:disabled).fc-button-active': {
      backgroundColor: '#333333',
      borderColor: '#333333',
    },
    '& .fc-daygrid-day': {
      borderColor: '#e0e0e0',
    },
    '& .fc-daygrid-day.fc-day-today': {
      backgroundColor: '#e3f2fd',
    },
    '& .fc-event': {
      fontFamily: 'Outfit, Roboto, Helvetica, Arial, sans-serif',
      border: 'none',
      borderRadius: '4px',
      padding: '2px 6px',
      fontSize: '12px',
      color: 'white',
    },
    '& .fc-event:hover': {
      opacity: 0.8,
    },
    '& .fc-daygrid-event': {
      marginBottom: '1px',
    },
    '& .fc-daygrid-day-number': {
      fontFamily: 'Outfit, Roboto, Helvetica, Arial, sans-serif',
      color: '#333',
      fontWeight: 500,
    },
    '& .fc-col-header-cell': {
      fontFamily: 'Outfit, Roboto, Helvetica, Arial, sans-serif',
      backgroundColor: '#f5f5f5',
      borderColor: '#e0e0e0',
      padding: '12px 8px',
      fontWeight: 600,
    },
  },
  legendContainer: {
    marginTop: 2,
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  legendColor: {
    width: 16,
    height: 16,
    borderRadius: '2px',
  },
};
